import { motion } from "framer-motion";
import type { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { Screen } from "../components/ui/editorial/Screen.js";
import { Topline } from "../components/ui/editorial/Topline.js";

const fadeIn = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
};

export function Splash(): JSX.Element {
  const navigate = useNavigate();

  return (
    <Screen tone="paper">
      {/* Топлайн — номер и статус беты */}
      <div className="px-[22px] pt-[48px]">
        <Topline left="№ I · апрель" right="бета · Москва" />
        <div className="mt-4 h-px bg-ink/14" />
      </div>

      {/* Нэймплейт — плотный центр */}
      <div className="flex flex-1 flex-col items-center justify-center px-[22px]">
        <motion.div
          {...fadeIn}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="text-center"
        >
          <h1
            className="font-display font-extralight leading-[0.88] tracking-[-0.05em] text-ink"
            style={{ fontSize: "clamp(72px, 22vw, 112px)" }}
          >
            Сп<em className="italic font-light text-accent">у</em>тник
          </h1>
          {/* Mark: горизонтальные hairlines + слово companion между ними */}
          <div className="mt-5 flex items-center justify-center gap-[14px] editorial-meta text-ink/55">
            <span className="h-px w-[36px] bg-ink/22" />
            <span>companion</span>
            <span className="h-px w-[36px] bg-ink/22" />
          </div>
        </motion.div>

        {/* Сабтайтл — суть без догмы про темп */}
        <motion.p
          {...fadeIn}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10 text-center font-display italic font-light text-[18px] leading-[1.45] text-ink/72"
        >
          знакомство —
          <br />в <em className="italic font-normal text-accent">письме</em>, не в ленте.
        </motion.p>
        <motion.p
          {...fadeIn}
          transition={{ duration: 0.9, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="mt-[10px] text-center editorial-meta text-ink/45"
        >
          темп — ваш
        </motion.p>
      </div>

      {/* HOOK — общий тизер, без имени-приманки */}
      <motion.div
        {...fadeIn}
        transition={{ duration: 0.9, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
        className="px-[42px] pb-[28px] text-center"
      >
        <div className="editorial-meta text-accent/90 flex items-center justify-center gap-[8px]">
          <motion.span
            aria-hidden
            className="inline-block h-[8px] w-[8px] rounded-full bg-accent"
            animate={{ opacity: [1, 0.35, 1], scale: [1, 0.8, 1] }}
            transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
          />
          <span>редакция открыта</span>
        </div>
        <p className="mt-[10px] font-display italic font-light text-[15px] leading-[1.45] text-ink/70">
          «сегодня подбираем вам <em className="italic font-normal text-ink">одного</em> человека —
          того, кому не надо объяснять ваши вечера.»
        </p>
      </motion.div>

      {/* CTA — текст-ссылка italic Fraunces */}
      <div className="px-[22px] pb-[14px] text-center">
        <button
          type="button"
          onClick={() => {
            navigate("/consent");
          }}
          className="font-display italic font-light text-[22px] tracking-[-0.01em] text-ink transition-opacity hover:opacity-80"
        >
          к письму <span className="ml-[6px] text-accent">→</span>
        </button>
      </div>

      {/* Колофон — тонкая линия + редакция / расписание (2 строки, центр — на мобиле не ломается) */}
      <div className="px-[22px] pb-[22px] text-center">
        <div className="mx-auto h-px w-[120px] bg-ink/18" />
        <div className="mt-[14px] editorial-meta text-ink/55">
          редакция ·{" "}
          <em className="italic font-light normal-case tracking-normal text-accent/90 text-[13px]">
            Марк · Юля · Лев
          </em>
        </div>
        <div className="mt-[4px] editorial-meta text-ink/40">несколько знакомств в день</div>
      </div>
    </Screen>
  );
}
